<div [ngClass]="cssClasses" class="need-help-container align-items-center d-md-flex d-none rounded-3 py-1 px-3 gap-2">
  <broker-phone-svg [cssClasses]="'d-block'"></broker-phone-svg>
  <span>{{ 'consumer.need-help.question' | translate: lang }}</span>
  <span>{{ 'consumer.need-help.answer' | translate: lang }}</span>
</div>
